// import Swiper bundle with all modules installed
import Swiper from '../../../node_modules/swiper/swiper-bundle.mjs';

window.Swiper = Swiper;